import Siema from 'siema';

export default {
  init() {
    // JavaScript to be fired on the home page
    // Init slider
    const slider = new Siema({
      selector: '.slider',
      loop: true,
      onChange: getSlideIndex,
    });

    // Create slide pagination
    Siema.prototype.addPagination = function() {
      let count = this.innerElements.length;
      if (count > 1) {
        for (let i = 0; i < count; i++) {
          const btn = document.createElement('button');
          btn.className = 'button-' + i;
          if (i == 0) {
            btn.className = 'button-' + i + ' active';
          }
          btn.addEventListener('click', () => this.goTo(i));
          let pagination = document.getElementById('pagination');
          pagination.appendChild(btn);
        }
      }
    };

    // Get the current slide index add class to active slide pagination
    function getSlideIndex() {
      let buttons = document.querySelectorAll('#pagination button');

      [].forEach.call(buttons, function(el) {
        el.classList.remove('active');
      });

      let button = 'button-' + this.currentSlide;
      document.getElementsByClassName(button)[0].className += ' active';
    }

    // Trigger pagination creator
    slider.addPagination();

    // Exit spalsh screen for IE 11 and below
    $('.static-circle').click(function() {
      $('.splash').fadeOut(750);
      $('.content--fixed').removeClass('content--fixed');
      document.cookie = 'hideSplash=true; expires=0; path=/';
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js